import { Field } from 'formik'
import SkeletonLoader from '@/Layout/SkeletonLoader'
import { formatNumberWithCommas } from '@/Utils/Other/FormatNumberWithCommas';

const BorderInputWithCommas = (props) => {
    const { inputProps, customClass, skeletonLoading, setFieldValue, minFollowerValue, maxFollowerValue } = props;

    const removeCommas = (number) => {
        return number ? number.toString().replace(/,/g, '') : '';
    };

    const handleChange = (e) => {
        const raw = removeCommas(e.target.value);

        if (/^\d*$/.test(raw)) {
            const numericValue = raw === '' ? '' : parseInt(raw);
            setFieldValue(inputProps.name, numericValue);
        }
    };

    const handleBlur = (e) => {
        const raw = removeCommas(e.target.value);
        let numericValue = parseInt(raw) || 0;

        if (inputProps.name === 'minFollower') {
            if (numericValue < minFollowerValue) numericValue = minFollowerValue;
            if (numericValue > maxFollowerValue) numericValue = maxFollowerValue;
        }

        if (inputProps.name === 'maxFollower') {
            if (numericValue > maxFollowerValue) numericValue = maxFollowerValue;
            if (numericValue < minFollowerValue) numericValue = minFollowerValue;
        }

        setFieldValue(inputProps.name, numericValue);
    };

    const displayValue = inputProps.value === '' ? '' : formatNumberWithCommas(inputProps.value);

    return (
        <>
            {skeletonLoading ? <SkeletonLoader height={54} rows={1} /> :
                <Field
                    {...inputProps}
                    className={`${customClass} appearance-none border border-neutral-200 bg-white rounded-2xl w-full py-3 px-4 text-sm font-medium text-neutral-900 placeholder:text-neutral-400 placeholder:font-normal focus:outline-none focus:border-primary/60 focus:ring-4 focus:ring-primary/15 focus-visible:outline-none transition-all duration-150`}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={displayValue}
                >
                </Field>
            }
        </>
    )
}

export default BorderInputWithCommas
